import React from 'react';
import { string, arrayOf } from 'prop-types';
import dynamic from 'next/dynamic';
import LazyLoad from 'components/LazyLoad';
import Html from 'components/Html';

const PLACEHOLDER = <div style={{ paddingBottom: '50%', width: '100%' }} />;

const dynamicOps = {
  ssr: false,
  loading: () => null
};

export const EMBEDS = {
  ceros: dynamic(() => import('./CerosEmbed'), dynamicOps),
  curalate: dynamic(() => import('./CuralateEmbed'), dynamicOps),
  facebook: dynamic(() => import('./FacebookEmbed'), dynamicOps),
  instagram: dynamic(() => import('./InstagramEmbed'), dynamicOps),
  reddit: dynamic(() => import('./RedditEmbed'), dynamicOps),
  twitter: dynamic(() => import('./TwitterEmbed'), dynamicOps),
  vimeo: dynamic(() => import('./VimeoEmbed'), dynamicOps),
  youtube: dynamic(() => import('./YoutubeEmbed'), dynamicOps)
};

const LAZY_LOAD_OFFSET = 200;

function ThirdPartyEmbed({ provider, url, raw, options }) {
  const EmbedComponent = EMBEDS[provider];

  // Render embed for known provider, or fall back to <Html />
  // Lazy load all embeds
  // CLEANUP: consider adding a static EmbedComponent.placeholder method to get
  // customized placeholders for each embed type.
  return (
    <LazyLoad placeholder={PLACEHOLDER} offset={LAZY_LOAD_OFFSET} once>
      {EmbedComponent ? (
        <EmbedComponent url={url} raw={raw} options={options} />
      ) : (
        <Html html={raw} />
      )}
    </LazyLoad>
  );
}

ThirdPartyEmbed.propTypes = {
  provider: string.isRequired,
  url: string,
  raw: string,
  options: arrayOf(string)
};

ThirdPartyEmbed.defaultProps = {
  options: [],
  url: undefined,
  raw: undefined
};

export default ThirdPartyEmbed;
